import { styled } from '@zenchef/styled-system/jsx'
import { CSSProperties } from 'react'
import { PopperChildrenProps } from 'react-popper'

interface TooltipProps {
  popper: any
  children: React.ReactNode
  specificStyles?: CSSProperties
}

export const Tooltip = ({ popper, children, specificStyles = {} }: TooltipProps) => (
  <styled.div
    ref={popper.ref}
    width='390px'
    maxWidth='calc(100vw - 10px)'
    maxHeight='calc(100dvh - 60px)'
    overflow='visible'
    style={{
      ...popper.styles,
      zIndex: 200,
      ...specificStyles
    }}
    data-placement={popper.placement}>
    {children}
  </styled.div>
)
